// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__19T--","footer":"ModalCreateQualiphyProcedure_footer__1QMyh","additionData":"ModalCreateQualiphyProcedure_additionData__1EkPq"};